import { INotification } from '@/store/modules/ui/interfaces'
import { ActionTree } from 'vuex'
import { RootState } from '@/store'
import { UiState } from '@/store/modules/ui/index'

export const actions: ActionTree<UiState, RootState> = {
  addNotification ({ getters, commit }, payload: INotification) {
    payload.id = `${Math.random()}-${Date.now()}`
    commit('setNotifications', [...getters.notifications, payload])
  },
  removeNotification ({ getters, commit }, payload: string) {
    commit('setNotifications', getters.notifications
      .filter((item: INotification) => item.id !== payload)
    )
  }
}
